  // Get all <details> elements with class 'details'
  const detailsElements = document.querySelectorAll('.pomverdeDetails');

  // Add event listener to each <details> element
  detailsElements.forEach(detail => {
    detail.addEventListener('toggle', function() {
      // If the current <details> is opened, close all other <details>
      if (detail.open) {
        detailsElements.forEach(otherDetail => {
          if (otherDetail !== detail && otherDetail.open) {
            otherDetail.removeAttribute('open');
          }
        });
      }
    });
  });